import decodeHTML from './html';

export const getNullableVariation = (artikel: Artikel, kEigenschaft: number): ArtikelVariation | null => {
  const variation = artikel.variationen.find((v) => v.kEigenschaft === kEigenschaft);
  if (!variation) {
    return null;
  }
  return variation;
};

export const getVariation = (artikel: Artikel, kEigenschaft: number): ArtikelVariation => {
  const variation = getNullableVariation(artikel, kEigenschaft);
  if (!variation) {
    throw new Error(`Variation mit kEigenschaft:${kEigenschaft} nicht im Artikel gefunden`);
  }
  return variation;
};

export const getKEigenschaftBreite = (artikel: Artikel): number => {
  const variation = artikel.variationen.find((v) => decodeHTML(v.cName).toLowerCase().includes('breite'))?.kEigenschaft;
  if (!variation) {
    throw new Error('Keine Variation für die Breite im Artikel gefunden');
  }
  return variation;
};

export const getKEigenschaftHoehe = (artikel: Artikel): number => {
  const variation = artikel.variationen.find((v) => decodeHTML(v.cName).toLowerCase().includes('höhe'))?.kEigenschaft;
  if (!variation) {
    throw new Error('Keine Variation für die Höhe im Artikel gefunden');
  }
  return variation;
};

export const getKEigenschaftLaenge = (artikel: Artikel): number => {
  const variation = artikel.variationen.find((v) => decodeHTML(v.cName).toLowerCase().includes('länge'))?.kEigenschaft;
  if (!variation) {
    throw new Error('Keine Variation für die Länge im Artikel gefunden');
  }
  return variation;
};

export const getKEigenschaftTiefe = (artikel: Artikel): number => {
  const variation = artikel.variationen.find((v) => decodeHTML(v.cName).toLowerCase().includes('tiefe'))?.kEigenschaft;
  if (!variation) {
    throw new Error('Keine Variation für die Tiefe im Artikel gefunden');
  }
  return variation;
};

export const getKEigenschaftVersand = (artikel: Artikel): number | null => {
  const variation = artikel.variationen.find((v) => decodeHTML(v.cName).toLowerCase().includes('versand'))?.kEigenschaft;
  if (!variation) {
    // eslint-disable-next-line no-console
    console.warn('Keine Variation für die Versand im Artikel gefunden');
    return null;
  }
  return variation;
};

export const getKEigenschaftMontageart = (artikel: Artikel): number => {
  const variation = artikel.variationen.find((v) => decodeHTML(v.cName).toLowerCase().includes('montage'))?.kEigenschaft;
  if (!variation) {
    throw new Error('Keine Variation für die Montageart im Artikel gefunden');
  }
  return variation;
};

export const getKEigenschaftWandschienenhoehe = (artikel: Artikel): number => {
  const variation = artikel.variationen.find((v) => decodeHTML(v.cName).toLowerCase().includes('schienenhöhe'))?.kEigenschaft;
  if (!variation) {
    throw new Error('Keine Variation für die Wandschienenhöhe im Artikel gefunden');
  }
  return variation;
};

export const getKEigenschaftVerstaerkung = (artikel: Artikel): number => {
  const variation = artikel.variationen.find((v) => decodeHTML(v.cName).toLowerCase().includes('verstärkung'))?.kEigenschaft;
  if (!variation) {
    throw new Error('Keine Variation für die Verstärkung im Artikel gefunden');
  }
  return variation;
};

export const getKEigenschaftStauhoehe = (artikel: Artikel): number => {
  const variation = artikel.variationen.find((v) => decodeHTML(v.cName).toLowerCase().includes('stauhöhe'))?.kEigenschaft;
  if (!variation) {
    throw new Error('Keine Variation für die Stauhöhe im Artikel gefunden');
  }
  return variation;
};

export const getKEigenschaftWert = (artikel: Artikel, kEigenschaft: number, cName: string): number => {
  const variation = artikel.variationen.find((v) => v.kEigenschaft === kEigenschaft);
  if (!variation) {
    throw new Error(`Variation mit kEigenschaft:${kEigenschaft} nicht im Artikel gefunden`);
  }
  const wert = variation.Werte.find((v) => v.cName === cName);
  if (!wert) {
    throw new Error(`Variation mit kEigenschaft:${kEigenschaft} enthält keinen Wert mit cName:${cName}`);
  }
  return wert.kEigenschaftWert;
};
